<evc-platform
  class="platform"
  inputForcedTheme="light"
  [inputAppIdentification]="appIdentification()"
  [i18nAppService]="i18nService">
  @if (ready()) {
    <main class="app _container">
      <div class="page">
        <router-outlet />
      </div>

      <footer class="footer">
        <shared-footer />
      </footer>
    </main>
  }
</evc-platform>
